import { Navigate, useParams } from 'react-router-dom';

import { useGetResponsable } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import {  SaveResponsable} from '../../shared/saveResponsable';

export interface UpdateResponsablePageInterface {}

const UpdateResponsablePage: React.FC<UpdateResponsablePageInterface> = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetResponsable(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_responsable) return <Navigate to="/activos/responsable" />;

  return <SaveResponsable titlePage="Editar Unidad del transporte" editResponsable={data.data} />;
};

export default UpdateResponsablePage;
